import { ComumModule } from '../comum/comum.module';
import { PipesModule } from '../comum/filtros/pipes/pipes.module';
import { routing } from '../rotas';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxPaginationModule } from 'ngx-pagination';
import { FormsModule } from '@angular/forms';
import { DashboardsService } from './dashboards.service';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { LoadingModule, ANIMATION_TYPES } from 'ngx-loading';
import { CadastroDashboardComponent } from './cadastro-dashboard/cadastro-dashboard.component';
import { ModalParametrosGraficoComponent } from './modal-parametros-grafico/modal-parametros-grafico.component';
import { ParametrosGraficoComponent } from './parametros-grafico/parametros-grafico.component';
import { VisualizarDashboardComponent } from './visualizar-dashboard/visualizar-dashboard.component';
import { ListarDashboardsComponent } from './listar-dashboards/listar-dashboards.component';
import { DashboardTileComponent } from './dashboard-tile/dashboard-tile.component';
import { ModalLayoutGraficoComponent } from './modal-layout-grafico/modal-layout-grafico.component';
import { LayoutGraficoComponent } from './layout-grafico/layout-grafico.component';
import { CalendarModule, ConfirmDialogModule, ConfirmationService, MultiSelectModule } from 'primeng/primeng';
import { CookieService } from 'angular2-cookie/services/cookies.service';
import { ClienteService } from '../cliente/cliente.service';

@NgModule({
  imports: [
    CommonModule,
    NgxPaginationModule,
    NgbModule.forRoot(),
    PipesModule,
    ComumModule,
    routing,
    FormsModule,
    LoadingModule.forRoot({
      animationType: ANIMATION_TYPES.circle
    }),
    CalendarModule,
    BrowserModule,
    BrowserAnimationsModule,
    NgxChartsModule,
    ConfirmDialogModule,
    MultiSelectModule
  ],
  declarations: [CadastroDashboardComponent, ModalParametrosGraficoComponent, ParametrosGraficoComponent,
    VisualizarDashboardComponent, ListarDashboardsComponent, DashboardTileComponent, ModalLayoutGraficoComponent, LayoutGraficoComponent],
  exports: [CadastroDashboardComponent, ModalParametrosGraficoComponent, ParametrosGraficoComponent,
    VisualizarDashboardComponent, ListarDashboardsComponent, DashboardTileComponent, ModalLayoutGraficoComponent, LayoutGraficoComponent],
  providers: [DashboardsService, ConfirmationService, CookieService, ClienteService],
  entryComponents: [
    DashboardTileComponent
  ]
})
export class DashboardsModule { }



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/dashboards/dashboards.module.ts